import { Search } from 'blaze-ui/icons'
import Styles from './SearchInput.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'

export interface SearchInputProps {
  onChange: (value: string) => void
  value: string
}

const SearchInput = ({ onChange, value }: SearchInputProps) => {
  return (
    <div className={Styles.searchField}>
      <Search />
      <Input
        className={Styles.searchInput}
        name="search"
        id="mediaUploadSearchForm"
        type="text"
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        placeholder="Search..."
        autoComplete="off"
        aria-label="Search Form Input"
        withBorder={false}
      />
    </div>
  )
}

export { SearchInput }
